import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Bell, Radio, ShoppingBag, MessageSquare, Gift, Gavel, LifeBuoy, Trash2, BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";
import { Loading, PageHead, Empty } from "@/components/common";

const ICONS = {
  seller_live: Radio, order: ShoppingBag, message: MessageSquare,
  giveaway_won: Gift, auction_won: Gavel, support: LifeBuoy,
  order_cancelled: ShoppingBag, verified: BadgeCheck,
};

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/notifications").then((d) => setItems(d.notifications)).catch(() => setItems([]));
    api.post("/notifications/read").catch(() => {});
    window.dispatchEvent(new Event("notif-read"));
  }, []);

  if (items === null) return <Loading />;

  const removeOne = async (e, id) => {
    e.stopPropagation();
    const prev = items;
    setItems((list) => list.filter((n) => n.id !== id));
    try { await api.del(`/notifications/${id}`); }
    catch (err) { toast.error(err.message); setItems(prev); }
  };
  const clearAll = async () => {
    if (!window.confirm("Clear all notifications?")) return;
    const prev = items;
    setItems([]);
    try { const res = await api.del("/notifications"); toast.success(`Cleared ${res.deleted} notification${res.deleted === 1 ? "" : "s"}`); }
    catch (err) { toast.error(err.message); setItems(prev); }
  };

  return (
    <div className="fade-up">
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
        <PageHead title="Notifications" sub="Live alerts, order updates and messages." />
        {items.length > 0 && (
          <button className="ss-btn ss-btn-ghost ss-btn-sm" style={{ color: "var(--red)" }} onClick={clearAll} data-testid="notif-clear-all"><Trash2 size={15} /> Clear all</button>
        )}
      </div>
      {items.length === 0 ? (
        <Empty icon={Bell} title="No notifications yet" sub="You'll be alerted when sellers you follow go live." />
      ) : (
        <div className="ss-card" style={{ overflow: "hidden" }} data-testid="notifications-list">
          {items.map((n) => {
            const Icon = ICONS[n.type] || Bell;
            return (
              <div key={n.id} className={`notif-row ${n.read ? "" : "unread"}`} onClick={() => n.action_url && navigate(n.action_url)} data-testid={`notif-${n.id}`}>
                <div className="notif-ic"><Icon size={18} /></div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 800 }}>{n.title}</div>
                  <div className="ss-muted" style={{ fontSize: 14, marginTop: 2 }}>{n.message}</div>
                </div>
                <button className="notif-del" onClick={(e) => removeOne(e, n.id)} title="Delete" data-testid={`notif-delete-${n.id}`}
                  style={{ background: "none", border: "none", cursor: "pointer", color: "var(--muted)", padding: 6, borderRadius: 8, flexShrink: 0 }}>
                  <Trash2 size={16} />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
